import styled from "styled-components";
import SvgDiv from "../SvgDiv";

interface StyledStepperProps extends React.ComponentPropsWithoutRef<"div"> {
  $customBackgroundColor?: string;
  $customBorderRadius?: string;
}

const StyledStepper = styled.div<StyledStepperProps>`
  background-color: ${({ $customBackgroundColor }) => $customBackgroundColor || "#F2F6FB"};
  border-radius: ${({ $customBorderRadius }) => $customBorderRadius || "12px 12px 0 0"};
  overflow-x: auto;
  padding: 24px;
  display: flex;
  gap: 20px;
  width: 100%;
  align-items: center;
  & > *:first-child {
    margin-left: auto;
  }
  & > *:last-child {
    margin-right: auto;
  }

  .label-step {
    white-space: nowrap;
    margin-top: 8px;
  }

  &.small {
    ${SvgDiv} {
      width: 24px;
      height: 24px;
    }
    .label-step {
      font-size: 14px;
      line-height: 21px;
    }
  }

  &.medium {
    ${SvgDiv} {
      width: 36px;
      height: 36px;
    }
    .label-step {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &.big {
    ${SvgDiv} {
      width: 48px;
      height: 48px;
    }
    .label-step {
      font-size: 20px;
      line-height: 30px;
    }
  }
`;

const StyledStep = styled.div`
    display: flex;
    text-align: center;
    flex-direction: row;
    align-items: flex-start;
`;

const StyledStepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  max-width: 80px;
  cursor: pointer;
`;

export {
  StyledStep,
  StyledStepWrapper,
  StyledStepper,
};
